import { gql } from '@apollo/client';

export const GET_CURRENT_VERSION = gql`
  query GetCurrentVersion($environment: String!) {
    currentVersion(environment: $environment) {
      id
      version
      ref
      environment
      deploymentId
      sha
      createdAt
      updatedAt
      deployedAt
      status
      description
    }
  }
`;

export const FORCE_VERSION_CHECK = gql`
  mutation ForceVersionCheck {
    forceVersionCheck
  }
`;
